import { render, staticRenderFns } from "./ClassRow.vue?vue&type=template&id=b0b893b4&scoped=true"
import script from "./ClassRow.vue?vue&type=script&lang=js"
export * from "./ClassRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b893b4",
  null
  
)

export default component.exports